document.addEventListener("DOMContentLoaded", () => {
  const form = document.getElementById("customer_information_form");
  const submitBtn = document.getElementById("customer_information_submit");
  const genderRadios = document.querySelectorAll("input[name='customer_information_courtesy_title']");
  const firstNameInput = document.getElementById("customer_information_first_name");
  const lastNameInput = document.getElementById("customer_information_last_name");
  const dobInput = document.getElementById("customer_information_dob");
  const emailInput = document.getElementById("customer_information_email");
  const countryCodeSelect = document.getElementById("customer_information_country_code");
  const phoneInput = document.getElementById("customer_information_phone");
  const errorBox = document.querySelector(".customer-information-error-message");
  const loader = submitBtn.querySelector(".loading-overlay");
  const submitText = submitBtn.querySelector(".customer-information-submit-text");
  const customerContainer = document.querySelector(".customer-information");
  const rightPanelBtn = document.querySelector("#customer_right_panel");

  // Toggle right panel
  if (rightPanelBtn) {
    rightPanelBtn.addEventListener("click", () => {
      customerContainer?.classList.remove("left-panel-mode");
    });
  }

  // Apps Script URL
  const scriptURL = "https://script.google.com/macros/s/AKfycbyeCA_qvBTw5X7cSspESt0v18uSgAbPOV1mhY6OLkiRVOMRuskIXh-QYrvWzSPsKDBu4A/exec";

  // Show/hide error messages
  const setError = (msg) => {
    errorBox.textContent = msg || "";
    errorBox.style.display = msg ? "block" : "none";
  };

  // Validation helpers
  const isEmailValid = () => /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/.test(emailInput.value.trim());
  const isPhoneValid = () => /^[6-9]\d{9}$/.test(phoneInput.value.trim());
  const isDOBValid = () => dobInput.value.trim() !== "";
  const isFirstNameValid = () => firstNameInput.value.trim() !== "";
  const isGenderValid = () => [...genderRadios].some(r => r.checked);

  const updateSubmitState = () => {
    const ok = isGenderValid() && isFirstNameValid() && isDOBValid() && isEmailValid() && isPhoneValid();
    const isLoading = submitBtn.dataset.loading === "1";
    submitBtn.disabled = !ok || isLoading;
    if (ok) setError("");
  };

  // Sanitize phone number
  phoneInput.addEventListener("input", () => {
    phoneInput.value = phoneInput.value.replace(/[^0-9]/g, "").slice(0, 10);
  });

  // Input listeners
  [firstNameInput, dobInput, emailInput, phoneInput].forEach(el => {
    el.addEventListener("input", updateSubmitState);
    el.addEventListener("change", updateSubmitState);
  });
  genderRadios.forEach(r => r.addEventListener("change", updateSubmitState));
  countryCodeSelect.addEventListener("change", updateSubmitState);

  // Blur validation
  emailInput.addEventListener("blur", () => {
    if (!isEmailValid()) setError("Please enter a valid email address.");
  });
  phoneInput.addEventListener("blur", () => {
    if (!isPhoneValid()) setError("Mobile number must be 10 digits and start with 6, 7, 8, or 9.");
  });

  // Clear error when editing email/mobile
  emailInput.addEventListener("input", () => setError(""));
  phoneInput.addEventListener("input", () => setError(""));

  // Initially disable
  submitBtn.disabled = true;

  // Submit handler
  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    updateSubmitState();
    if (submitBtn.disabled) return;

    // Lock UI
    submitBtn.dataset.loading = "1";
    loader.style.opacity = "1";
    submitText.style.opacity = "0";
    setError("");

    // Collect values
    const gender = [...genderRadios].find(r => r.checked)?.value || "";
    const firstName = firstNameInput.value.trim();
    const lastName = lastNameInput.value.trim();
    const dob = dobInput.value.trim();
    const email = emailInput.value.trim();
    const mobile = `${countryCodeSelect.value}${phoneInput.value.trim()}`;

    // Prepare payload
    const payload = new URLSearchParams();
    payload.append("gender", gender);
    payload.append("first_name", firstName);
    payload.append("last_name", lastName);
    payload.append("dob", dob);
    payload.append("email", email);
    payload.append("mobile", mobile);

    try {
      const res = await fetch(scriptURL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload
      });
      const result = await res.json();

      // Unlock UI
      submitBtn.dataset.loading = "0";
      loader.style.opacity = "0";
      submitText.style.opacity = "1";

      if (result.result === "success") {
        customerContainer?.classList.add("left-panel-mode");

        // Send to MoEngage
        if (typeof Moengage !== "undefined") {
          Moengage.add_email(email);
          Moengage.add_mobile(mobile);
          Moengage.add_unique_user_id(email);
          Moengage.add_first_name(firstName);
          Moengage.add_last_name(lastName);
          Moengage.add_user_attribute("DOB", dob);
          Moengage.add_user_attribute("Mobile Number (Standard)", mobile);
          Moengage.add_user_attribute("Registered Via", "Walk Naturally Campaign");

          Moengage.track_event("Walk Naturally Submit", {
            "Email": email,
            "Mobile": mobile,
            "First Name": firstName,
            "Last Name": lastName,
            "Gender": gender,
            "DOB": dob,
            "Device": navigator.userAgent,
            "Source": "Shopify"
          });
        }

        // Reset form
        form.reset();
        document.getElementById("customer_information_courtesy_title_mr").checked = true;
        updateSubmitState();

      } else {
        // Show specific backend error
        if (result.reason === "email") setError("This email address has already been registered.");
        else if (result.reason === "mobile") setError("This mobile number is already in use.");
        else if (result.reason === "both") setError("This email and mobile number have already been used.");
        else setError(result.message || "An unexpected error occurred.");

        // Keep button enabled for retry
        submitBtn.disabled = false;
      }
    } catch (err) {
      setError("Unable to connect. Please try again later.");
      submitBtn.dataset.loading = "0";
      loader.style.opacity = "0";
      submitText.style.opacity = "1";
      submitBtn.disabled = false;
    }
  });
});
